import React, { FC } from 'react'
import styled from 'styled-components'

import theme from '@app/ui/theme'
import { ErrorMessage } from '@ui/blocks/ErrorMessage'
import { Label } from '@ui/blocks/Label'

const FormGroup = styled.div`
  position: relative;
`

const StyledTextInput = styled.input<any>`
  box-sizing: border-box;
  width: 100%;
  height: 5.4rem;
  padding: 0 2rem;
  font-size: 1.6rem;
  line-height: 4.8rem;
  -webkit-appearance: none;
  border: 1px solid
    ${({ error, variant }) => {
      if (error) return `${theme.global.colors.red}`
      switch (variant) {
        case 'green':
          return `
            ${theme.global.colors.greenInputBorder};
          `
        case 'deepSea':
          return `
            ${theme.global.colors.patina};
          `
        default:
          return `
            ${theme.global.colors.whiteInputBorder};
          `
      }
    }};
  border-radius: 1000px;
  outline: transparent;
  ${({ variant }) => {
    switch (variant) {
      case 'green':
        return `
          background-color: ${theme.global.colors.greenInputBg};
          color: ${theme.global.colors.greenInputText};
        `
      case 'deepSea':
        return `
          background-color: ${theme.global.colors.deepSeaGreen};
          color: ${theme.global.colors.patina};
        `
      default:
        return `
          background-color: ${theme.global.colors.whiteInputBg};
          color: ${theme.global.colors.whiteInputText};
        `
    }
  }};
  ::placeholder {
    color: ${({ variant }) => {
      switch (variant) {
        case 'green':
          return `${theme.global.colors.greenInputPlaceholder};`
        case 'deepSea':
          return `${theme.global.colors.patina};`
        default:
          return `${theme.global.colors.whiteInputPlaceholder};`
      }
    }};
  }

  :focus {
    border-color: ${({ variant, error }) => {
      if (error) return `${theme.global.colors.red}`
      switch (variant) {
        case 'green':
          return `${theme.global.colors.lightGreen};`
        case 'deepSea':
          return `${theme.global.colors.lightGreen};`
        default:
          return `${theme.global.colors.easternBlue};`
      }
    }};
  }
`

export const TextInput: FC<any> = ({ className, id, label, register, error, silentError, onChange, ...rest }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (typeof onChange !== 'undefined') {
      onChange(e.target.value)
    }
  }

  return (
    <FormGroup className={className}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <StyledTextInput error={error} id={id} ref={register} onChange={handleChange} {...rest} />
      {error && !silentError && <ErrorMessage>{error}</ErrorMessage>}
    </FormGroup>
  )
}
